import { PortableTextMarkComponentProps } from '@portabletext/react'
import cx from 'classnames'

import {
  SanityBlockColoredText,
  SanityColoredTextColorValue,
} from '@data/sanity/queries/types/content'

type ColoredTextValue = Pick<SanityBlockColoredText, '_type' | 'color'>

const colorClasses: Record<SanityColoredTextColorValue, string> = {
  white: 'text-white',
  black: 'text-black',
  yellow: 'text-yellow',
}

const ColoredText = ({
  value,
  children,
}: PortableTextMarkComponentProps<ColoredTextValue>) => {
  const colorClass = value?.color ? colorClasses[value.color] : ''

  return <span className={cx(colorClass)}>{children}</span>
}

export default ColoredText
